import React from 'react'
import AboutHome from './AboutHome';
import Direction from './Direction';
import Features from './Features';
import VideoPlayer from './VideoPlayer';
import Partner from './Partner';
import Sliderr from './Sliderr';
import Team from './Team';
import TopSlider from './TopSlider';
import Why from './Why';
import CustomModal from './CustomModal';

const Home = () => {
    return <div className="element">
        <TopSlider />
        <AboutHome/>
        <Features />
        <VideoPlayer />
        <Why />
        <Partner />
        <Team />
        {/* <Sliderr /> */}
        <Direction />
        <CustomModal />

    </div>;
};

export default Home;